export default __webpack_public_path__ + "static/media/dashboard.98c339c2.svg";